import { render, staticRenderFns } from "./OpenAndClose.vue?vue&type=template&id=2b6b0db8&scoped=true"
import script from "./OpenAndClose.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenAndClose.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpenAndClose.vue?vue&type=style&index=0&id=2b6b0db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b0db8",
  null
  
)

export default component.exports